import { useEffect, useState } from "react";
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";
import { showAlert, showErrorAlert } from "../../../components/molecules/ShowAlert";
import { getAllRegistros } from "../../../services/registro.service";
import { getAllEstudiantes } from "../../../services/estudiante.service";
import { getAllInscripciones } from "../../../services/inscripcion.service";
import { getOneTipoAdmision } from "../../../services/tipoAdmision.service";
import { getOnePrograma } from "../../../services/programa.service";
import { getOneGrupo } from "../../../services/grupo.service";
import { getOneModulo } from "../../../services/modulo.service";
import { CongeladoList } from "../../../modules/estudiante/CongeladoList";

const parsearFechaApi = (fechaString) => {
  if (!fechaString) return null;
  return new Date(fechaString);
};


const esCongelado = (registro = {}) => {
  const estado = registro.estado?.trim().toLowerCase() || "";
  if (estado === "congeladovol" || estado === "congeladoint") return true;

  if (registro.estaCongelado === true) return true;

  const tipo = registro.tipoCongelacion?.trim().toLowerCase();
  if (tipo === "voluntario" || tipo === "institucional") return true;

  return false;
};

export const CongeladosPage = () => {
  const [mes, setMes] = useState("");
  const [anio, setAnio] = useState("");
  const [congelados, setCongelados] = useState([]);
  const [busqueda, setBusqueda] = useState("");

  useEffect(() => {
    cargarDatos();
  }, [mes, anio]);

  const cargarDatos = async () => {
    try {
      const [registros, estudiantes, inscripciones] = await Promise.all([
        getAllRegistros(),
        getAllEstudiantes(),
        getAllInscripciones(),
      ]);

      console.log("=== [CongeladosPage] Registros crudos ===", registros);
      const dicEstudiantes = {};
      for (const est of estudiantes) {
        const idEst = est.estudiante?.idEstudiante?.trim();
        if (idEst) {
          dicEstudiantes[idEst] = est;
        }
      }

      const soloCongelados = registros.filter((reg) => esCongelado(reg));
      const filtradosPorMesAnio = soloCongelados.filter((reg) => {
        const fechaBase = reg.fechaCongelado || reg.fechaRegistro;
        const fecha = parsearFechaApi(fechaBase);
        if (!fecha) {
          return false;
        }
        const mesBD = fecha.getMonth() + 1;
        const anioBD = fecha.getFullYear();

        const coincideMes = mes ? mesBD === Number(mes) : true;
        const coincideAnio = anio ? anioBD === Number(anio) : true;
        return coincideMes && coincideAnio;
      });

      console.log("=== [CongeladosPage] Registros tras mes/año ===", filtradosPorMesAnio);

      const transformados = await Promise.all(
        filtradosPorMesAnio.map(async (registro) => {
          const idEst = registro.idEstudiante?.trim();
          const estudianteEncontrado = dicEstudiantes[idEst];

          if (!estudianteEncontrado) {
            console.warn("No se encontró el estudiante con ID:", idEst);
            return {
              persona: { nombre: "No encontrado", apellido: "" },
              estudiante: { idEstudiante: idEst, tipoAdmision: "N/A" },
              inscripcion: { programa: { nombre: "N/A" } },
              registro: {
                ...registro,
                grupo: { nombre: "N/A", modulo: { nombre: "N/A" } },
              },
            };
          }
          let tipoAdmisionNombre = "N/A";
          if (estudianteEncontrado.estudiante?.idTipoAdmision) {
            try {
              const tipoAdmisionInfo = await getOneTipoAdmision(
                estudianteEncontrado.estudiante.idTipoAdmision
              );
              tipoAdmisionNombre = tipoAdmisionInfo?.nombre || "N/A";
            } catch (error) {
              console.error("Error obteniendo Tipo de Admisión:", error);
            }
          }

          const inscripcionEncontrada = inscripciones.find(
            (ins) => ins.idEstudiante === idEst
          );

          let nombrePrograma = "N/A";
          if (inscripcionEncontrada?.idPrograma) {
            try {
              const programaInfo = await getOnePrograma(inscripcionEncontrada.idPrograma);
              nombrePrograma = programaInfo?.nombre || "N/A";
            } catch (error) {
              console.error("Error obteniendo Programa:", error);
            }
          }
          let grupoData = { nombre: "N/A", modulo: { nombre: "N/A" } };
          if (registro.idGrupo) {
            try {
              const grupoInfo = await getOneGrupo(registro.idGrupo);
              if (grupoInfo) {
                grupoData.nombre = grupoInfo.nombre;
                if (grupoInfo.idModulo) {
                  const moduloInfo = await getOneModulo(grupoInfo.idModulo);
                  grupoData.modulo = moduloInfo
                    ? { nombre: moduloInfo.nombre }
                    : { nombre: "N/A" };
                }
              }
            } catch (error) {
              console.error("Error obteniendo grupo/modulo:", error);
            }
          }
          return {
            persona: estudianteEncontrado.persona,
            estudiante: {
              ...estudianteEncontrado.estudiante,
              tipoAdmision: tipoAdmisionNombre,
              idEstudiante: idEst,
            },
            inscripcion: { programa: { nombre: nombrePrograma } },
            registro: {
              ...registro,
              grupo: grupoData,
            },
          };
        })
      );

      console.log("=== [CongeladosPage] transformados final ===", transformados);
      setCongelados(transformados);
    } catch (error) {
      console.error("Error al cargar registros congelados:", error);
      showErrorAlert({
        text: "Error al cargar los registros de estudiantes congelados",
        icon: "error",
      });
    }
  };

  const handleDelete = (idEstudiante) => {
    setCongelados((prev) =>
      prev.filter((c) => c.estudiante.idEstudiante !== idEstudiante)
    );
  };

  const congeladosFiltrados = congelados.filter((cong) => {
    const nombreCompleto = `${cong.persona?.nombre || ""} ${cong.persona?.apellido || ""}`.toLowerCase();
    const celular = cong.persona?.celular?.toLowerCase() || "";
    const tipoAdmision = cong.estudiante?.tipoAdmision?.toLowerCase() || "";
    const programaNombre = cong.inscripcion?.programa?.nombre?.toLowerCase() || "";
    const grupoNombre = cong.registro?.grupo?.nombre?.toLowerCase() || "";
    const moduloNombre = cong.registro?.grupo?.modulo?.nombre?.toLowerCase() || "";
    const tipoCongelado = cong.registro?.tipoCongelacion?.toLowerCase() || "";

    const texto = busqueda.toLowerCase();
    return (
      nombreCompleto.includes(texto) ||
      celular.includes(texto) ||
      tipoAdmision.includes(texto) ||
      programaNombre.includes(texto) ||
      grupoNombre.includes(texto) ||
      moduloNombre.includes(texto) ||
      tipoCongelado.includes(texto) 
    );
  });
  
  return (
    <ContenedorPageTemplate
      objetos={congelados}
      dirIcono="/img/iconos/estudiante_que_va_en_medio.svg"
      titulo="Estudiantes Congelados"
    >
      <div className="flex flex-col justify-start items-start">
        <p>
          <span className="text-lg font-semibold">
            Total de congelados: {congeladosFiltrados.length || 0}
          </span>
        </p>
      </div>

      <div className="flex gap-4 py-3">
        <select
          value={mes}
          onChange={(e) => setMes(e.target.value)}
          className="border rounded-lg p-2"
        >
          <option value="">Todos los meses</option>
          {Array.from({ length: 12 }, (_, i) => (
            <option key={i + 1} value={i + 1}>
              {new Date(0, i).toLocaleString("es", { month: "long" })}
            </option>
          ))}
        </select>

        <select
          value={anio}
          onChange={(e) => setAnio(e.target.value)}
          className="border rounded-lg p-2"
        >
          <option value="">Todos los años</option>
          {Array.from({ length: 5 }, (_, i) => {
            const year = new Date().getFullYear() + i - 2;
            return (
              <option key={year} value={year}>
                {year}
              </option>
            );
          })}
        </select>
      </div>

      <div className="flex gap-4 py-3">
        <input
          type="text"
          placeholder="Buscar por nombre, apellido, teléfono, tipo de admisión, programa, grupo, módulo o tipo de congelado"
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          className="flex-1 text-black border shadow-sm rounded-xl py-3 px-4
                     focus:ring-1 focus:border-blue-500 focus:ring-blue-300
                     transition-colors hover:border-blue-500 border-slate-200"
        />
      </div>

      <CongeladoList congelados={congeladosFiltrados} onDelete={handleDelete} />
    </ContenedorPageTemplate>
  );
};
